import { f7 } from 'framework7-react';
import PaperflyAPI, {
  getResponseErrorMessage
} from '../../server/api/PaperflyAPI';
import { saveTemplatesUserData, setRequestIdCookie } from '../../lib/utils';
import { flushPendingSourcePdfs } from '../../lib/pendingSourcePdfs';
import { clearStandaloneDraft } from '../../lib/standaloneDraftCache';
import { create_UUID, isIterable } from '../utils';
import {
  DOC_TYPE_DOCUMENT,
  DOC_TYPE_ID_CHECK,
  DOC_TYPE_IMMEDIATE_CONFIRMATION,
  DOC_TYPE_INFORMATION
} from '../../components/helpers/utils';
import { resolveRecipientName } from '../../components/helpers/userFieldsData';
import { getConnectSessionCredentials } from '../../components/home/utils';
import { gaeApp } from '../../components/helpers/Analytics';
import II18 from '../../components/translate/II18';
import { createSendRequestTask, SEND_REQUEST_STATUS } from '../sendRequestTask';
import { CREATE_TEMPLATE_REQUEST_STATUS } from '../createTemplateRequestTask';
import { USER_CREDENTIALS_STATUS } from '../userCredentialsTask';
import { createLatestWinsAsyncQueue } from '../../lib/latestWinsAsyncQueue';

/** Serializes intermediary put; concurrent saves keep latest payload only. */
const saveDocumentsQueue = createLatestWinsAsyncQueue();

export const RESET_APP = 'RESET_APP';
export const RESTART_APP = 'RESTART_APP';
export const SET_LANDSCAPE_MODE = 'SET_LANDSCAPE_MODE';
export const SET_PREVIEW_DATA = 'SET_PREVIEW_DATA';
export const SET_DEVICE_ID = 'SET_DEVICE_ID';
export const SET_VIRTUAL_KEYBOARD_OPEN = 'SET_VIRTUAL_KEYBOARD_OPEN';
export const SET_ACTUAL_SCREEN_SIZE = 'SET_ACTUAL_SCREEN_SIZE';
export const APP_CRASH = 'APP_CRASH';
export const SET_SELECTED_LANG = 'SET_SELECTED_LANG';
export const SET_TEMPLATE_MODE_OFF = 'SET_TEMPLATE_MODE_OFF';
export const RECEIVE_BAD_REQUEST = 'RECEIVE_BAD_REQUEST';
export const SET_SHOW_RESTORE_DIALOG = 'SET_SHOW_RESTORE_DIALOG';
export const SET_OTP_REQUEST_ID = 'SET_OTP_REQUEST_ID';
export const SET_OPT_VERIFY_DONE = 'SET_OPT_VERIFY_DONE';
export const SET_CROSS_DEVICE_DOCUMENT_LOADED =
  'SET_CROSS_DEVICE_DOCUMENT_LOADED';
export const SET_REQUEST_START_INFO = 'SET_REQUEST_START_INFO';
export const RECEIVE_ERROR_ON_PREPARE_FROM_TEMPLATE =
  'RECEIVE_ERROR_ON_PREPARE_FROM_TEMPLATE';

export const REQUEST_CREATE_REQUEST_FROM_TEMPLATE =
  'REQUEST_CREATE_REQUEST_FROM_TEMPLATE';
export const REQUEST_LIST_REQUESTED_DOCUMENTS =
  'REQUEST_LIST_REQUESTED_DOCUMENTS';
export const RECEIVE_LIST_REQUESTED_DOCUMENTS =
  'RECEIVE_LIST_REQUESTED_DOCUMENTS';

export const REQUEST_LIST_TEMPLATE_DOCUMENTS =
  'REQUEST_LIST_TEMPLATE_DOCUMENTS';

export const SET_CREATE_TEMPLATE_REQUEST_TASK =
  'SET_CREATE_TEMPLATE_REQUEST_TASK';
export const SET_USER_CREDENTIALS_TASK = 'SET_USER_CREDENTIALS_TASK';

export const REQUEST_CREATE_DEMO_REQUEST = 'REQUEST_CREATE_DEMO_REQUEST';
export const RECEIVE_CREATE_DEMO_REQUEST = 'RECEIVE_CREATE_DEMO_REQUEST';

export const RECEIVE_SIGNATURE_FROM_MOBILE = 'RECEIVE_SIGNATURE_FROM_MOBILE';
export const RECEIVE_CROSS_DEVICE_DATA = 'RECEIVE_CROSS_DEVICE_DATA';
export const RECEIVE_CROSS_DEVICE_DOCUMENT_COMPLETED_EVENT =
  'RECEIVE_CROSS_DEVICE_DOCUMENT_COMPLETED';
export const SET_DOCUMENTS_LIST_PAGE = 'SET_DOCUMENTS_LIST_PAGE';

export const REQUEST_SAVED_DOCUMENTS = 'REQUEST_SAVED_DOCUMENTS';
export const RECEIVE_SAVED_DOCUMENTS = 'RECEIVE_SAVED_DOCUMENTS';
export const REQUEST_SAVE_DOCUMENTS = 'REQUEST_SAVE_DOCUMENTS';
export const RECEIVE_SAVE_DOCUMENTS = 'RECEIVE_SAVE_DOCUMENTS';
export const RECEIVE_STANDALONE_DRAFT = 'RECEIVE_STANDALONE_DRAFT';

export const SET_DOCUMENT_FORM = 'SET_DOCUMENT_FORM';
export const SET_DOCUMENT_COLLECT_BIO_DATA_CONFIRMED =
  'SET_DOCUMENT_COLLECT_BIO_DATA_CONFIRMED';
export const SET_ATTACHMENT_PRINTED = 'SET_ATTACHMENT_PRINTED';

export const SET_DOCUMENT_DATA_URL = 'SET_DOCUMENT_DATA_URL';
export const UPDATE_DOCUMENT_PAGES_ORDER = 'UPDATE_DOCUMENT_PAGES_ORDER';
export const REMOVE_DOCUMENT_PAGE = 'REMOVE_DOCUMENT_PAGE';

export const SET_CAMERA_MODE = 'SET_CAMERA_MODE';
export const SET_PRIVACY_ACCEPTED = 'SET_PRIVACY_ACCEPTED';
export const SET_USERS_DATA = 'SET_USERS_DATA';
export const SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA';
export const SET_SCAN_STARTED = 'SET_SCAN_STARTED';
export const SET_EXECUTE_ONE_DOCUMENT_ON_MOBILE =
  'SET_EXECUTE_ONE_DOCUMENT_ON_MOBILE';
export const SET_SIGNATURE_CACHE = 'SET_SIGNATURE_CACHE';
export const SET_SIGNATURE_TOUCH_DATA = 'SET_SIGNATURE_TOUCH_DATA';
export const SET_SCAN_ENDED = 'SET_SCAN_ENDED';
export const SET_SEND_REQUEST = 'SET_SEND_REQUEST';
export const SET_SEND_REQUEST_TASK = 'SET_SEND_REQUEST_TASK';
export const SET_DOCUMENT_STATUS = 'SET_DOCUMENT_STATUS';
export const SET_DOCUMENT_VISITED = 'SET_DOCUMENT_VISITED';
export const SET_DOCUMENT_REJECTED = 'SET_DOCUMENT_REJECTED';
export const UNSET_DOCUMENT_REJECTED = 'UNSET_DOCUMENT_REJECTED';
export const UPDATE_DOCUMENT_STATUS = 'UPDATE_DOCUMENT_STATUS';
export const SET_SUCCESS_SENT_KEYS = 'SET_SUCCESS_SENT_KEYS';
export const SET_ERROR_SENT_KEYS = 'SET_ERROR_SENT_KEYS';
export const SET_CROP_IS_HIDDEN = 'SET_CROP_IS_HIDDEN';
export const SHOW_REJECT_DOCUMENT_DIALOG = 'SHOW_REJECT_DOCUMENT_DIALOG';
export const HIDE_REJECT_DOCUMENT_DIALOG = 'HIDE_REJECT_DOCUMENT_DIALOG';
export const SET_SHOW_MAIN_INFO_POPUP = 'SET_SHOW_MAIN_INFO_POPUP';
export const SET_SHOW_USER_CREDENTIAL_FORM = 'SET_SHOW_USER_CREDENTIAL_FORM';
export const SET_SCANNED_DOCUMENTS = 'SET_SCANNED_DOCUMENTS';
export const SET_REQUEST_STEP_SUBMITTED = 'SET_PAGE_SUBMITTED';

export const SHARE_ACTIVE_DOCUMENT_STATE = 'SHARE_ACTIVE_DOCUMENT_STATE';

export const SET_EXTERNAL_POPUP_WINDOW_OPEN = 'SET_EXTERNAL_POPUP_WINDOW_OPEN';
export const PREPARE_EXTERNAL_POPUP_WINDOW_OPEN =
  'PREPARE_EXTERNAL_POPUP_WINDOW_OPEN';

export const COMMUNUCATION_CHANNEL = {
  IN_PERSON: 'IN_PERSON',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  POSTAL: 'POSTAL'
};
export const EXTERNAL_POPUP_WINDOW_STATUS = {
  OPEN: 'OPEN',
  PREPARE: 'PREPARE',
  CLOSE: 'CLOSE'
};

export const EXTERNAL_POPUP_WINDOW_TYPE = {
  SIGNME: 'SIGN_ME',
  YES: 'YES',
  ATRUST: 'A_TRUST'
};

export const ESIGNATURE_TYPE = {
  AES: 'AES',
  SIGNME: 'SIGN_ME',
  YES: 'YES',
  ATRUST: 'A_TRUST'
};

export const SIGNME_REGISTRATION_STATUS = {
  OK: 'OK',
  FAILED: 'FAILED',
  CANCEL: 'CANCEL'
};

export function setExternalPopUpWindowStatus(status) {
  return {
    type: SET_EXTERNAL_POPUP_WINDOW_OPEN,
    payload: status
  };
}

export function restartApp() {
  return {
    type: RESTART_APP
  };
}

export function shareActiveDocumentState(documentType, sharedState) {
  return {
    type: SHARE_ACTIVE_DOCUMENT_STATE,
    documentType,
    sharedState
  };
}

export function prepareExternalPopUpWindow(winInfo) {
  return {
    type: PREPARE_EXTERNAL_POPUP_WINDOW_OPEN,
    payload: winInfo
  };
}

export function setLandscapeMode(mode) {
  return {
    type: SET_LANDSCAPE_MODE,
    payload: mode
  };
}

export function setPreviewData(data) {
  return {
    type: SET_PREVIEW_DATA,
    payload: data
  };
}

export function setDevicesId(id) {
  return {
    type: SET_DEVICE_ID,
    payload: id
  };
}

export function setVirtualKeyboardOpen(open) {
  return {
    type: SET_VIRTUAL_KEYBOARD_OPEN,
    payload: open
  };
}

export function setActualScreenSize(size) {
  return {
    type: SET_ACTUAL_SCREEN_SIZE,
    payload: size
  };
}

function requestSaveDocuments() {
  return { type: REQUEST_SAVE_DOCUMENTS };
}

function receiveSaveDocuments(response) {
  return { type: RECEIVE_SAVE_DOCUMENTS, response };
}

export function showRejectDocumentDialog(docId) {
  return { type: SHOW_REJECT_DOCUMENT_DIALOG, docId };
}

export function setShowMainInfoPopUp(opened) {
  return { type: SET_SHOW_MAIN_INFO_POPUP, payload: opened };
}

export function setShowUserCredentialForm(payload) {
  return { type: SET_SHOW_USER_CREDENTIAL_FORM, payload };
}

//Bad Request
export function receiveBadRequest(error) {
  return { type: RECEIVE_BAD_REQUEST, errorMessage: error.message };
}

//Requested Documents
function requestListRequestedDocuments(recipientRequestId) {
  return { type: REQUEST_LIST_REQUESTED_DOCUMENTS, recipientRequestId };
}

export function requestListTemplateDocuments() {
  return {
    type: REQUEST_LIST_TEMPLATE_DOCUMENTS
  };
}

function requestCreateDemoRequest() {
  return { type: REQUEST_CREATE_DEMO_REQUEST };
}

function requestSavedDocuments(recipientRequestId) {
  return { type: REQUEST_SAVED_DOCUMENTS, recipientRequestId };
}

function requestCreateRequestFromTemplate() {
  return { type: REQUEST_CREATE_REQUEST_FROM_TEMPLATE };
}

function receiveErrorOnPrepareFromTemplate(errorMessage) {
  return { type: RECEIVE_ERROR_ON_PREPARE_FROM_TEMPLATE, errorMessage };
}

export function setAttachmentPrinted(documentId, as) {
  return { type: SET_ATTACHMENT_PRINTED, documentId, as };
}

export function resetAndStartAppNew(newRequestStartInfo) {
  return { type: RESET_APP, newRequestStartInfo };
}

export function switchTemplateModeToNormalRequest() {
  return { type: SET_TEMPLATE_MODE_OFF };
}

export function setSelectedLang(payload) {
  return { type: SET_SELECTED_LANG, payload };
}

export function setShowRestoreDialog(on) {
  return { type: SET_SHOW_RESTORE_DIALOG, on };
}

export function setDocumentDataUrl(documentId, pageId, dataUrl) {
  const preparedPages = new Map();
  if (isIterable(dataUrl)) {
    for (let url of dataUrl) {
      preparedPages.set(create_UUID('xxxxxxxx'), url);
    }
  } else {
    preparedPages.set(pageId ? pageId : create_UUID('xxxxxxxx'), dataUrl);
  }
  return { type: SET_DOCUMENT_DATA_URL, documentId, preparedPages };
}

export function setDocumentForm(documentId, form) {
  return { type: SET_DOCUMENT_FORM, documentId, form };
}

/** Merge demo/test field values into the preview document form (iframe host). */
export function fillPreviewFormData(documentId, formDataObject) {
  return (dispatch, getState) => {
    if (!window.previewMode) {
      return;
    }
    const existing = getState().forms.get(documentId) || new Map();
    const merged = new Map(existing);
    Object.entries(formDataObject || {}).forEach(([key, value]) => {
      merged.set(key, value);
    });
    dispatch(setDocumentForm(documentId, merged));
  };
}

export function setDocumentCollectBioDataConfirmed(documentId) {
  return { type: SET_DOCUMENT_COLLECT_BIO_DATA_CONFIRMED, documentId };
}

export function updateDocumentPagesOrder(documentId, oldIndex, newIndex) {
  return { type: UPDATE_DOCUMENT_PAGES_ORDER, documentId, oldIndex, newIndex };
}

export function removeDocumentPage(documentId, pageId) {
  return { type: REMOVE_DOCUMENT_PAGE, documentId, pageId };
}

export function setCameraMode(as) {
  return { type: SET_CAMERA_MODE, as };
}

export function setPrivacyAccepted(as) {
  return { type: SET_PRIVACY_ACCEPTED, as };
}

export function setUsersData(data) {
  return { type: SET_USERS_DATA, data };
}

export function setRegistrationData(data) {
  return { type: SET_REGISTRATION_DATA, data };
}

export function setSuccessSentKeys(keysMap) {
  return { type: SET_SUCCESS_SENT_KEYS, keysMap };
}

export function setErrorSentKeys(keysMap) {
  return { type: SET_ERROR_SENT_KEYS, keysMap };
}

export function setScanStarted(startedFrom) {
  return { type: SET_SCAN_STARTED, startedFrom };
}

export function setSignatureCache(data) {
  return { type: SET_SIGNATURE_CACHE, data };
}

export function setSignatureTouchData(formId, signatureId, data) {
  return { type: SET_SIGNATURE_TOUCH_DATA, formId, signatureId, data };
}

export function setScanEnded() {
  return { type: SET_SCAN_ENDED };
}

export function setSendRequestTask(task) {
  return { type: SET_SEND_REQUEST_TASK, payload: task };
}

export function startSendRequest({
  fromDocView = false,
  tillPage,
  noProgressDialog = false,
  skipThankyou = false
} = {}) {
  return setSendRequestTask(
    createSendRequestTask({
      status: SEND_REQUEST_STATUS.SENDING,
      fromDocView,
      tillPage,
      noProgressDialog,
      skipThankyou
    })
  );
}

export function stopSendRequest() {
  return setSendRequestTask(null);
}

export function setCreateTemplateRequestTask(task) {
  return {
    type: SET_CREATE_TEMPLATE_REQUEST_TASK,
    payload: task
  };
}

export function clearCreateTemplateRequestTask() {
  return setCreateTemplateRequestTask(null);
}

export function cancelCreateTemplateRequest() {
  return setCreateTemplateRequestTask({
    status: CREATE_TEMPLATE_REQUEST_STATUS.CANCELLED
  });
}

export function setUserCredentialsTask(task) {
  return {
    type: SET_USER_CREDENTIALS_TASK,
    payload: task
  };
}

export function clearUserCredentialsTask() {
  return setUserCredentialsTask(null);
}

export function cancelUserCredentialsTask() {
  return setUserCredentialsTask({
    status: USER_CREDENTIALS_STATUS.CANCELLED
  });
}

export function completeUserCredentialsTask() {
  return setUserCredentialsTask({
    status: USER_CREDENTIALS_STATUS.DONE
  });
}

export function setRequestStepSubmitted(pageId) {
  return { type: SET_REQUEST_STEP_SUBMITTED, pageId };
}

export function setScannedDocuments(payload) {
  return { type: SET_SCANNED_DOCUMENTS, payload };
}

export function setDocumentPayed(documentId, method) {
  return {
    type: SET_DOCUMENT_STATUS,
    documentId,
    status: method ? method : true
  };
}

export function setIdCheckDocumentType(documentId, docType) {
  return {
    type: UPDATE_DOCUMENT_STATUS,
    documentId,
    status: {
      idCheckDocumentType: docType
    }
  };
}

export function setDocumentStatus(documentId, status) {
  return {
    type: SET_DOCUMENT_STATUS,
    documentId,
    status
  };
}

export function setDocumentVisited(documentId) {
  return {
    type: SET_DOCUMENT_VISITED,
    documentId
  };
}

export function setDocumentRejected(documentId) {
  return {
    type: SET_DOCUMENT_REJECTED,
    documentId
  };
}

export function unSetDocumentRejected(documentId) {
  return {
    type: UNSET_DOCUMENT_REJECTED,
    documentId
  };
}

export function setDocumentPdfUploaded(documentId, fileName) {
  return { type: SET_DOCUMENT_STATUS, documentId, status: fileName };
}

export function receiveSignatureFromMobile(response) {
  return { type: RECEIVE_SIGNATURE_FROM_MOBILE, response };
}

export function receiveCreateDemoRequest(response) {
  return { type: RECEIVE_CREATE_DEMO_REQUEST, response };
}

export function receiveCrossDeviceDocumentCompletedEvent(response) {
  return {
    type: RECEIVE_CROSS_DEVICE_DOCUMENT_COMPLETED_EVENT,
    response
  };
}

/**
 * receiveCrossDeviceRequest
 *
 * @param {{
 * crossDeviceDocument: {
 *  id: string,
 *  recipientRequestId: string,
 *  downloadUrl: string,
 *  documentId: string,
 *  completed: boolean,
 *  embedded: boolean,
 *  documentOptions: *
 *  },
 *  putUrl: string,
 *  downloadUrl: string}} response
 * @returns {{crossDeviceId, putUrl, recipientRequestId, downloadUrl, documentId, completed: *, type: string, documentData: *, embedded}}
 */
export function receiveCrossDeviceRequest(response) {
  return {
    type: RECEIVE_CROSS_DEVICE_DATA,
    crossDeviceRequest: {
      crossDeviceId: response.crossDeviceDocument.id,
      documentId: response.crossDeviceDocument.documentId,
      completed: response.crossDeviceDocument.completed,
      documentOptions: response.crossDeviceDocument.documentOptions,
      putUrl: response.putUrl || '',
      downloadUrl: response.downloadUrl || ''
    },
    templateMode: response.crossDeviceDocument.embedded,
    recipientRequestId: response.crossDeviceDocument.recipientRequestId
  };
}

export function setCurrentRequestPageIndex(pageIndex) {
  return { type: SET_DOCUMENTS_LIST_PAGE, pageIndex };
}

function receiveSavedDocuments(response) {
  return {
    type: RECEIVE_SAVED_DOCUMENTS,
    requestedDocuments: response.infoMessage
      ? false
      : response.paperflyRequest.requestedDocuments
  };
}

export function receiveStandaloneDraft(draftState) {
  return {
    type: RECEIVE_STANDALONE_DRAFT,
    draftState
  };
}

function receiveListPreparedRequestedDocuments(response, recipientRequestId) {
  return {
    ...receiveListRequestedDocuments(response, recipientRequestId),
    templateMode: false,
    templateRequestPrepared: true
  };
}

export function receiveListRequestedDocumentsTemplate(
  response,
  recipientRequestId
) {
  return {
    ...receiveListRequestedDocuments(response, recipientRequestId),
    templateMode: true
  };
}

function receiveListRequestedDocuments(response, recipientRequestId) {
  return {
    type: RECEIVE_LIST_REQUESTED_DOCUMENTS,
    recipientRequestId: recipientRequestId || response.requestId,
    recipientId: response.recipientId,
    recipientEmail: response.recipientEmail,
    recipientPhone: response.recipientPhone,
    caseName: response.caseName,
    requestedDocuments: response.requestedDocuments,
    infoMessage: response.infoMessage,
    errorCode: response.errorCode,
    expirationDate: response.expirationDate,
    submittedDate: response.lastSubmit,
    emailMessage: response.message,
    requestMessage: response.requestMessage,
    recipientName: response.recipientName,
    state: response.state,
    closed:
      response.state === 'CLOSED' || response.state === 'CLOSED_AFTER_SUBMIT',
    submitted:
      response.state === 'SUBMITTED' || response.state === 'SUBMITTING',
    actionButtonLabel: response.actionButtonLabel,
    completeButtonLabel: response.completeButtonLabel,
    customConfirmationPageText: response.customConfirmationPageText,
    companyName: response.requester,
    companyEmail: response.requesterEmail,
    companyLogo: response.requesterLogoUrl,
    canSaveDocuments: response.intermediaryStorageEnabled,
    brandingDetails: response.brandingDetails || {},
    analyticsDisabled: response.googleAnalyticsDisabled,
    pwaCanApplySignature: response.pwaCanApplySignature,
    embeddingFields: response.embeddingFields || [],
    communicationChannel: response.communicationChannel,
    customizationKey: response.customizationKey,
    qesProvider: response.qesProvider,
    qesFirstName: response.qesFirstName,
    qesLastName: response.qesLastName,
    qesValueInheritance: response.qesValueInheritance,
    authenticationState: response.authenticationState,
    authenticationType: response.authenticationType,
    requestPages: response.pages,
    documentConditions: response.documentConditions,
    recipientConditions: response.recipientConditions,
    valueInheritance: response.valueInheritance,
    documentRejectionAllowed: response.documentRejectionAllowed,
    skipStartPage: response.noStartPagePwa,
    embeddingFieldsInheritance: response.embeddingFieldsInheritance || {},
    recipients: response.recipients,
    language: response.language,
    region: response.region,
    paperflyRequestProgress: response.paperflyRequestProgress
  };
}

export function saveDocuments(
  recipientRequestId,
  requestedDocuments,
  scannedDocuments,
  forms,
  documentsStatus
) {
  return dispatch =>
    saveDocumentsQueue.schedule(() => {
      if (window.previewMode || recipientRequestId === 'preview_request') {
        return Promise.resolve();
      }
      dispatch(requestSaveDocuments(recipientRequestId));
      const documentsToSave = [];

      for (const [id, pages] of scannedDocuments.entries()) {
        documentsToSave.push({
          id: id,
          attributes: {
            attachments: Array.from(pages.keys()),
            sourcePdf:
              requestedDocuments.get(id).type === DOC_TYPE_DOCUMENT &&
              documentsStatus.get(id)
          }
        });
      }
      for (const [id, form] of forms.entries()) {
        const jsonData = {};
        Array.from(form).forEach(([key, value]) => (jsonData[key] = value));
        documentsToSave.push({
          id: id,
          attributes: {
            formData: jsonData
          }
        });
      }
      for (const [id, status] of documentsStatus.entries()) {
        if (
          requestedDocuments.get(id).type === DOC_TYPE_IMMEDIATE_CONFIRMATION ||
          requestedDocuments.get(id).type === DOC_TYPE_INFORMATION
        ) {
          documentsToSave.push({
            id: id,
            attributes: status
          });
        }
        if (requestedDocuments.get(id).type === DOC_TYPE_ID_CHECK) {
          const idCheckDocumentIndex = documentsToSave.findIndex(
            doc => doc.id === id
          );
          if (idCheckDocumentIndex === -1) {
            documentsToSave.push({
              id: id,
              attributes: {
                idDocumentType: status.idCheckDocumentType
              }
            });
          } else {
            documentsToSave[idCheckDocumentIndex].attributes.idDocumentType =
              status.idCheckDocumentType;
          }
        }
      }
      // Resolves true/false so a forced reload can wait for the save.
      return PaperflyAPI.tempDataPush(recipientRequestId, documentsToSave).then(
        response => {
          dispatch(receiveSaveDocuments(response));
          return true;
        },
        err => {
          console.log(err);
          return false;
        }
      );
    });
}

export function loadSavedDocuments(recipientRequestId, check) {
  return dispatch => {
    if (window.previewMode || recipientRequestId === 'preview_request') {
      return Promise.resolve();
    }
    dispatch(requestSavedDocuments(recipientRequestId));
    return PaperflyAPI.tempDataPull(recipientRequestId).then(
      response => {
        if (check) {
          return dispatch({
            type: SET_SHOW_RESTORE_DIALOG,
            on: Boolean(
              !response.infoMessage &&
                response.paperflyRequest.requestedDocuments.length
            )
          });
        } else {
          dispatch(receiveSavedDocuments(response));
          return true;
        }
      },
      err => {
        dispatch({
          type: SET_SHOW_RESTORE_DIALOG,
          on: false
        });
        return false;
      }
    );
  };
}

export function prepareTemplateRequest(templateId, usersData, options = {}) {
  return (dispatch, getState) => {
    if (window.previewMode) {
      return Promise.resolve();
    }

    const skipPreparingDialog = Boolean(options.skipPreparingDialog);
    if (!skipPreparingDialog) {
      f7.dialog.preloader(II18.get('title_preparing'));
    }
    dispatch(requestCreateRequestFromTemplate());

    const closePreloader = () => {
      if (!skipPreparingDialog) {
        f7.dialog.close();
        f7.dialog.destroy();
      }
    };

    const params = getState().requestStartInfo?.params;
    const { sessionId, deviceId } =
      params?.embed === 'true' ? getConnectSessionCredentials(params) : {};

    return PaperflyAPI.createRequestFromTemplate(
      templateId,
      usersData,
      window.testMode,
      sessionId,
      deviceId
    ).then(
      response => {
        if (response.errorCode) {
          closePreloader();
          dispatch(receiveBadRequest({ message: response.infoMessage }));
          dispatch(receiveErrorOnPrepareFromTemplate(response.infoMessage));
        } else {
          gaeApp('REQUEST_PREPARED_WITH_ID', response.recipientRequestId);
          return PaperflyAPI.listRequestedDocuments(
            response.recipientRequestId
          ).then(
            listResponse => {
              setRequestIdCookie(response.recipientRequestId);

              if (window.standalone) {
                saveTemplatesUserData(
                  resolveRecipientName(usersData[0]),
                  usersData[0].userEmail,
                  usersData[0].userFields
                );
              }
              if (window.draftEnabled) {
                clearStandaloneDraft();
              }

              return flushPendingSourcePdfs(
                response.recipientRequestId,
                (documentId, fileName) => {
                  dispatch(setDocumentPdfUploaded(documentId, fileName));
                }
              ).then(() => {
                closePreloader();
                dispatch(
                  receiveListPreparedRequestedDocuments(
                    listResponse,
                    response.recipientRequestId
                  )
                );
              });
            },
            error => {
              closePreloader();
              dispatch(receiveBadRequest(error));
              dispatch(
                receiveErrorOnPrepareFromTemplate(
                  getResponseErrorMessage(error)
                )
              );
            }
          );
        }
      },
      error => {
        closePreloader();
        dispatch(receiveBadRequest(error));
        dispatch(
          receiveErrorOnPrepareFromTemplate(getResponseErrorMessage(error))
        );
      }
    );
  };
}

export function loadCrossDeviceRequest(crossDeviceId) {
  return dispatch => {
    return PaperflyAPI.crossDeviceDocumentGet(crossDeviceId).then(
      response => {
        if (response.crossDeviceDocument) {
          dispatch(receiveCrossDeviceRequest(response));
        } else
          dispatch(receiveBadRequest({ message: 'WRONG_CROSS_DEVICE_ID' }));
      },
      err => dispatch(receiveBadRequest(err))
    );
  };
}

export function createDemoRequest(demoId) {
  return dispatch => {
    dispatch(requestCreateDemoRequest());

    return PaperflyAPI.createAndGetDemoRequestId(demoId).then(
      response => {
        if (!response.recipientRequestId) {
          dispatch(receiveBadRequest({ message: 'WRONG_DEMO_ID' }));
          return;
        }

        dispatch(receiveCreateDemoRequest(response.recipientRequestId));
      },
      err => dispatch(receiveBadRequest(err))
    );
  };
}

export function listRequestedDocumentsTemplate(templateId) {
  return (dispatch, getState) => {
    dispatch(requestListTemplateDocuments());

    const { sessionId, deviceId } = getConnectSessionCredentials(
      getState().requestStartInfo?.params
    );

    return PaperflyAPI.listRequestedDocumentsTemplate(
      templateId,
      sessionId,
      deviceId
    ).then(
      response =>
        dispatch(receiveListRequestedDocumentsTemplate(response, templateId)),
      error => dispatch(receiveBadRequest(error))
    );
  };
}

export function listRequestedDocuments(requestId, securePinOrOtpRequestId) {
  return (dispatch, getState) => {
    dispatch(requestListRequestedDocuments(requestId));

    const { sessionId, deviceId } = getConnectSessionCredentials(
      getState().requestStartInfo?.params
    );

    return PaperflyAPI.listRequestedDocuments(
      requestId,
      securePinOrOtpRequestId,
      sessionId,
      deviceId
    ).then(
      response => dispatch(receiveListRequestedDocuments(response, requestId)),
      error => dispatch(receiveBadRequest(error))
    );
  };
}

export function setOtpRequestId(otpRequestId) {
  return {
    type: SET_OTP_REQUEST_ID,
    payload: otpRequestId
  };
}

export function setRequestStartInfo(requestInfo) {
  return {
    type: SET_REQUEST_START_INFO,
    payload: requestInfo
  };
}

export function setOptVerifyDone() {
  return {
    type: SET_OPT_VERIFY_DONE
  };
}

export function setCrossDeviceDocumentLoaded() {
  return {
    type: SET_CROSS_DEVICE_DOCUMENT_LOADED
  };
}
